import { Edit, PeopleAlt, Schedule } from '@mui/icons-material';
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { VisitFinishReason as VisitFinishReasonType } from '../../api/types/visits';

interface Props {
  visitFinishReason: VisitFinishReasonType;
}

export const VisitFinishReason: FC<Props> = ({ visitFinishReason }) => {
  const { t } = useTranslation(['visit']);

  const getVisitFinishReasonIcon = (reason: VisitFinishReasonType) => {
    switch (reason) {
      case VisitFinishReasonType.MANUAL:
        return <Edit />;
      case VisitFinishReasonType.AUTOMATIC_VISITORS_LEFT_BUILDING:
        return <PeopleAlt />;
      case VisitFinishReasonType.AUTOMATIC_TIME_FINISHED:
        return <Schedule />;
      default:
        return null;
    }
  };

  return (
    <>
      <Card variant="outlined">
        <CardHeader title={t('visit:finish.title')} variant="outlined" />
        <Divider />
        <CardContent>
          <Typography
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: 'primary.main',
              gap: 1,
            }}
            variant="overline">
            {getVisitFinishReasonIcon(visitFinishReason)}
            {t(`visit:finish.${visitFinishReason}`)}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};
